import { render, staticRenderFns } from "./TradingInfoSideDrawer.vue?vue&type=template&id=14223ecc&scoped=true"
import script from "./TradingInfoSideDrawer.ts?vue&type=script&lang=ts&external"
export * from "./TradingInfoSideDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./TradingInfoSideDrawer.vue?vue&type=style&index=0&id=14223ecc&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14223ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14223ecc')) {
      api.createRecord('14223ecc', component.options)
    } else {
      api.reload('14223ecc', component.options)
    }
    module.hot.accept("./TradingInfoSideDrawer.vue?vue&type=template&id=14223ecc&scoped=true", function () {
      api.rerender('14223ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/SideDrawers/TradingInfoSideDrawer.vue"
export default component.exports